 total_accounts=5;
 total_records=0;

 document.addEventListener('DOMContentLoaded', function() {
    total_records=$('.number-inner').children().length/3;
});

